import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { CommandHistoryItem } from '@contracts/index';

export interface HistoryState {
  commands: CommandHistoryItem[];
  maxEntries: number;
}

const initialState: HistoryState = {
  commands: [],
  maxEntries: 500
};

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    recordCommand: (state, action: PayloadAction<CommandHistoryItem>) => {
      state.commands.unshift(action.payload);
      if (state.commands.length > state.maxEntries) {
        state.commands.pop();
      }
    },
    clearHistory: (state) => {
      state.commands = [];
    }
  }
});

export const { recordCommand, clearHistory } = historySlice.actions;

export default historySlice.reducer;
